import { Routes } from '@angular/router';
import { ownerGuard } from '../../auth/guards/owner.guard';

export const workItemsRoutes: Routes = [
  {
    path: 'work-items',
    canActivate: [ownerGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/work-items-page/work-items-page.component').then(
            (m) => m.WorkItemsPageComponent,
          ),
      },
      {
        path: ':id',
        canActivate: [ownerGuard],
        loadComponent: () =>
          import('./pages/work-item-details-page/work-item-details-page.component').then(
            (m) => m.WorkItemDetailsPageComponent,
          ),
      },
    ],
  },
];
